import { Typography } from 'antd'
import { TitleProps } from 'antd/lib/typography/Title'

export const Title: React.FC<TitleProps> = (props) => <Typography.Title {...props} />
